import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { TimeWindowDto } from "../../../models/time-window/dto/time-window.dto";

export const GET_TIME_WINDOWS_QUERY_KEY = (groupId: string) => ['timeWindows', groupId];

export const useGetTimeWindows = (groupId: string) => {
    const client = useApiClient();
    return useQuery({
        // Today every caller passes a group id straight off a listed row, so
        // this is the cheap half of defence in depth rather than a live bug —
        // but `time-windows/groups/undefined/windows` is one absent prop away,
        // and the id check belongs with the id rather than with the callers.
        enabled: Boolean(groupId),
        queryKey: GET_TIME_WINDOWS_QUERY_KEY(groupId),
        queryFn: () => client.fetchApi<TimeWindowDto[], void>({
            endpoint: `time-windows/groups/${groupId}/windows`,
            method: 'GET'
        }),
        staleTime: 30_000
    });
};